import { BellRing, Landmark, Plug } from "lucide-react";
import {
  INTEGRATION_CATALOG,
  INTEGRATION_TYPES,
} from "@tribunalea/shared";
import {
  PjmNotificationsIntegrationPage,
} from "../pages/PjmNotificationsIntegrationPage.jsx";
import { PjnScwIntegrationPage } from "../pages/PjnScwIntegrationPage.jsx";

const implementations = Object.freeze({
  [INTEGRATION_TYPES.PJM_NOTIFICATIONS]: Object.freeze({
    icon: BellRing,
    page: PjmNotificationsIntegrationPage,
  }),
  [INTEGRATION_TYPES.PJN_SCW]: Object.freeze({
    icon: Landmark,
    page: PjnScwIntegrationPage,
  }),
});

const definitions = Object.freeze(INTEGRATION_CATALOG.map((definition) =>
  Object.freeze({
    ...definition,
    ...implementations[definition.type],
  })));

const byType = new Map(definitions.map((item) => [item.type, item]));
const byRoute = new Map(definitions.map((item) => [item.route, item]));

export const integrationRegistry = definitions;

export function integrationDefinition(type) {
  return byType.get(type) || null;
}

export function integrationDefinitionForRoute(route) {
  return byRoute.get(route) || null;
}

export function integrationIcon(type) {
  return integrationDefinition(type)?.icon || Plug;
}
